module.exports = __webpack_public_path__ + "img/stock_h.a268f4cc.svg";